import(/* webpackMode: "eager" */ "/vercel/path0/components/MailLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
